module.exports = __webpack_public_path__ + "img/double-arrow-up.936ae2f7.svg";